import { aStarTitles } from './constants';
import ImageUpload from './ImageUpload';
import Alert from './Alert';
import {
  getDealInfoHtml,
  getEvaluateReviewAreaHtml,
  getRateInputHtml,
  getWriteReviewHtml,
  getReviewBenefitAreaHtml,
  getConfirmAreaHtml,
  getNotifyPopupHtml,
} from './WriteHtmls';
import AppRating from './AppRating';

export default class Write {
  constructor(htOptions, oModule) {
    this.bAjaxRegister = false; // 등록중인가?

    this.sSatisfyPoint = 0; // 상품만족도
    this.sDeliveryPoint = 0; // 배송만족도

    this.nReviewTextLimit = 600; // 리뷰의 최대 글자 수
    this.nPrevReviewCount = 0; // 입력한 문자 길이

    this.htOptions = htOptions;
    this.welContainer = htOptions.welContainer;

    this.oModule = oModule;
    this.sMainDealSrl = TMON.util.gup('mainDealSrl');
    this.sMainBuySrl = TMON.util.gup('mainBuySrl');

    this.oImageUpload = new ImageUpload(this.welContainer);
    this.oAlert = new Alert(this.welContainer);
    this.oAppRating = new AppRating();
  }

  show(bIsModify, sReviewNo, sDealType, sReviewType) {
    if (TMON.sDevice === 'MA' || TMON.sDevice === 'MI') {
      TMON.app.callApp(
        'webview',
        'setWebProperties',
        '{"isKeyboardResize":true}'
      ); // Android 앱에서 텍스트 입력창이 키보드에 가려지지않게 자동으로 스크롤 되도록 callApp을 날려준다.
    }
    $(window).scrollTop(0);
    this.bIsModify = bIsModify;
    this.sReviewNo = sReviewNo;
    this.sDealType = sDealType;
    this.sReviewType = sReviewType;
    if (bIsModify) {
      this.showModifyMode(sReviewNo);
    } else {
      this.showWriteMode();
      this.wel.show();
    }

    $('body').addClass('review-write');
  }

  showWriteMode() {
    if (this.wel) {
      this.wel.remove();
    }

    const htEmptyData = {
      contents: '',
      dealGpoint: 0,
      deliveryGpoint: 0,
      hasImage: false,
    };

    this.processRendering(htEmptyData);
  }

  showModifyMode(sReviewNo) {
    if (this.wel) {
      this.wel.remove();
    }
    this.getReviewForModify(sReviewNo);
  }

  getReviewForModify(sReviewNo) {
    $.ajax({
      url: this.oModule.getApi().getReview.replace('{ReviewNo}', sReviewNo),
      data: {
        useHeader: TMON.bLogin ? 'MN' : '',
        useDealInfo: false,
      },
      success: res => {
        if (!res || !res.data) {
          alert('존재하지 않는 리뷰입니다.');
          this.afterComplete();
          return;
        }

        this.sMainDealSrl = res.data.mainDealNo;
        this.oImageUpload.setMainDealSrl(res.data.mainDealNo);
        this.sMainBuySrl = res.data.mainBuyNo;
        this.sSatisfyPoint = res.data.dealGpoint;
        this.sDeliveryPoint = res.data.deliveryGpoint;

        if (!res.data.contents) {
          // 리뷰타입 S의 경우 후기 작성을 하지 않는다.
          this.sReviewType = 'S';
        } else {
          this.sReviewType = '';
        }

        if (res.data.deliveryGpoint > 0) {
          // 딜타입이 배송딜이 아니면 deliveryGpoint 값이 0 이다.
          this.sDealType = 'DELIVERY';
        } else {
          this.sDealType = '';
        }

        this.processRendering(res.data);
        this.wel.show();
        this.onKeyUp();
      },
    });
  }

  processRendering(htRenderData) {
    this.htRenderData = htRenderData;

    this.render(htRenderData);
    this.renderNotifyPopup();

    this.wel = this.welContainer.find('.review_write_area:first');

    this.cacheElement();

    this.oImageUpload.init();
    this.oImageUpload.showIosPhotoAuth();

    this.getDealInfo();
    this.getDeliveryInfo();
    this.getReviewSurveyInfo();

    this.setEvent();
  }

  render(htData) {
    const sHtml = `<div class="review_write_area">
                <div data-role="review_write_toast" class="review_toast_recommend" style="display:none;">
                    <p class="text">추천해주셔서 감사합니다.</p>
                </div>
                <h1 class="review_write_title">리뷰쓰기</h1>
                <span class="review_write_sub">구매 후 리뷰를 작성하시면 <span class="point_color_orange f_bold">적립금 10원</span>을 드립니다.</span>
                ${
                  /* 구매 딜 및 옵션 정보 */
                  getDealInfoHtml()
                } ${
      /* 상품 평가하기 영역 */
      getEvaluateReviewAreaHtml(
        this.sDealType,
        htData.dealGpoint,
        htData.deliveryGpoint
      )
    } ${
      /* 리뷰 쓰기 영역 */
      getWriteReviewHtml(
        this.sReviewType,
        htData.contents,
        htData.hasImage,
        htData.imageInfo,
        this.oImageUpload
      )
    } ${
      /* 리뷰 작성시 혜택 안내 */
      getReviewBenefitAreaHtml()
    }
                <div class="review_write_info" ${
                  this.sReviewType === 'S' ? '' : 'style="display:none;"'
                }>
                    <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_review_info"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="ico_review_info"><g><circle id="Oval" stroke="#959DA6" fill="#FFFFFF" cx="7" cy="7" r="6.5"></circle><g id="Group" transform="translate(6.500000, 3.500000)" fill="#959DA6"><rect id="Rectangle" x="0" y="0" width="1" height="5"></rect><rect id="Rectangle-Copy-2" x="0" y="6" width="1" height="1"></rect></g></g></g></g></svg>
                    <p class="info_text">리뷰를 등록할 수 없는 상품입니다.<br>과대광고 방지를 위해 만족도만 선택 가능합니다</p>
                </div>
                ${
                  /* 리뷰 쓰기/취소 버튼 */
                  getConfirmAreaHtml(this.bIsModify)
                }
            </div>`;

    this.welContainer.append(sHtml);
  }

  renderNotifyPopup() {
    this.welContainer.append(getNotifyPopupHtml());
    this.welNoticePopup = this.welContainer.find('[role=writePopup]');
  }

  cacheElement() {
    this.welSatisfyStar = this.wel.find('._saStar');
    this.welSatisfyTitle = this.wel.find('._saTitle');

    this.welDeliveryStar = this.wel.find('._deStar');
    this.welDeliveryTitle = this.wel.find('._deTitle');

    this.welContents = $('#reviewContents');
    this.welTextCounter = this.wel.find('.text_count em');

    this.welWriteInfo = this.wel.find('._reviewWriteInfo');
  }

  /**
   * 구매한 딜 정보를 가져온다.
   */
  getDealInfo() {
    if (this.oAjaxGetDealInfo) {
      this.oAjaxGetDealInfo.abort();
    }

    this.oAjaxGetDealInfo = $.ajax({
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      url: `${this.oModule.getApi().getDealInfo}?dealNos=${
        this.sMainDealSrl
      }&validationType=NONE`,
      success: res => {
        this.oAjaxGetDealInfo = null;
        if (!res || !res.data || !res.data[0]) {
          this.onErrorGetDealInfo();
          return;
        }
        this.htDealInfo = res.data[0];
        this.wel.find('._reviewWriteTitle').html(this.htDealInfo.titleName);
        if (this.htDealInfo.imageInfo) {
          this.wel
            .find('._reviewImage')
            .css(
              'background-image',
              `url(${
                this.htDealInfo.imageInfo.mobile3ColImageUrl
                  ? this.htDealInfo.imageInfo.mobile3ColImageUrl
                  : this.htDealInfo.imageInfo.mobileImageUrl
              })`
            );
        } else {
          this.wel
            .find('._reviewImage')
            .parent()
            .hide();
        }
      },
    });
  }

  onErrorGetDealInfo() {
    alert('잠시 후 다시 시도해주세요.');
  }

  /**
   * 구매한 옵션 딜 정보를 가져온다.
   */
  getDeliveryInfo() {
    if (this.oAjaxGetDeliveryInfo) {
      this.oAjaxGetDeliveryInfo.abort();
    }

    this.oAjaxGetDeliveryInfo = $.ajax({
      method: 'GET',
      url: this.oModule.getApi().getDeliveryInfo,
      data: {
        main_buy_srl: this.sMainBuySrl,
      },
      success: res => {
        this.oAjaxGetDeliveryInfo = null;

        let sHtml = '';
        let nCount = 0;
        // 구매한 옵션딜을 표시한다.
        Object.keys(res.data).forEach(sKey => {
          Object.keys(
            res.data[sKey].main_deals[this.sMainDealSrl].buy_deals
          ).forEach(sBuyDealKey => {
            sHtml += `<li class="_buyOptionItem deal_option_item">
                                <span class="deal_option_sub">${
                                  res.data[sKey].main_deals[this.sMainDealSrl]
                                    .buy_deals[sBuyDealKey].buy_option_title
                                }</span>
                            </li>`;
            nCount += 1;
          });
        });

        this.wel.find('._buyOption').html(sHtml);
        if (nCount >= 2) {
          this.wel.find('[role=reviewWriteMore]').show();
        } else {
          this.wel.find('[role=reviewWriteMore]').hide();
        }
      },
    });
  }

  getReviewSurveyInfo() {
    if (this.oAjaxGetReviewSurveyInfo) {
      this.oAjaxGetReviewSurveyInfo.abort();
    }

    this.oAjaxGetReviewSurveyInfo = $.ajax({
      method: 'GET',
      url: this.oModule
        .getApi()
        .reviewSurveyItems.replace('{mainDealNo}', this.sMainDealSrl),
      success: res => {
        this.oAjaxGetReviewSurveyInfo = null;

        if (res.data.length > 0) {
          const sHtml = getRateInputHtml(res.data, this.htRenderData);
          this.wel
            .find('#_reviewSurvey')
            .append(sHtml)
            .show();

          this.htSurveyItems = {};
          Object.keys(res.data).forEach(idx => {
            this.htSurveyItems[
              res.data[idx].reviewItem.reviewSurveyItemNo
            ] = null;

            if (this.htRenderData && this.htRenderData.reviewSurveyList) {
              this.htRenderData.reviewSurveyList.forEach(elem => {
                this.htSurveyItems[elem.reviewSurveyItemNo] =
                  elem.reviewSurveyItemSelectionNo;
              });
            }
          });
        }
      },
    });
  }

  setEvent() {
    // 구매 옵션 펼치기
    this.wel.on('click', '[role=reviewWriteMore]', this.onClickOpenOption);

    // 상품 만족도
    this.wel.on('click', '._saStar', this.onClickSatisfyStar);
    // 배송 만족도
    this.wel.on('click', '._deStar', this.onClickDeliveryStar);

    // 상품 평가항목
    this.wel.on('click', '._surveyItem', this.onClickSurveyItem);

    // 리뷰 작성시 유의사항 팝업 보이기
    this.wel.on('click', '[role=showWritePop]', this.showWriteNoticePopup);
    // 리뷰 작성시 유의사항 팝업 숨기기
    this.welNoticePopup.on(
      'click',
      '[role=closeWritePop]',
      this.hideWriteNoticePopup
    );
    // 리뷰 내용 변경
    this.welContents.keyup(this.onKeyUp);
    // bugfix(SDLUI-1091), 모바일 붙여넣기 시 안내문구와 겹치는 현상 수정
    this.welContents.on('paste', e => {
      let clipboardText;
      // clipboardData에 저장된 텍스트 가져오기, window는 originalEvent 없음
      if (e.originalEvent.clipboardData) {
        clipboardText = e.originalEvent.clipboardData.getData('text/plain');
      } else {
        clipboardText = window.clipboardData.getData('text');
      }
      const clipboardTextLen = clipboardText.length;
      if (clipboardTextLen > 0) {
        this.onKeyUp(clipboardText);
      }
    });

    // 업로드된 이미지 삭제
    this.wel.on('click', '[role=removeImage]', this.removeImage);

    // 리뷰 작성시 혜택 안내 더보기 버튼 제어
    this.welWriteInfo.on('click', 'button', this.onClickMoreBtn);

    // 취소
    this.wel.on('click', '[role=cancel]', this.onClickCancel);
    // 등록·수정하기
    this.wel.on('click', '[role=register]', this.onClickRegister);
  }

  // 구매 옵션 펼치기 eventListener
  onClickOpenOption = () => {
    this.wel.find('[data-role=reviewWriteOption]').toggleClass('open');
  };

  // 상품 만족도
  onClickSatisfyStar = e => {
    this.sSatisfyPoint = $(e.currentTarget).val();
    this.welSatisfyStar.removeClass('on');
    this.welSatisfyStar.filter(`:lt(${this.sSatisfyPoint})`).addClass('on');
    this.welSatisfyTitle.html(aStarTitles[this.sSatisfyPoint]);
    $('._saTitle').addClass('on');
  };

  // 배송 만족도
  onClickDeliveryStar = e => {
    this.sDeliveryPoint = $(e.currentTarget).val();
    this.welDeliveryStar.removeClass('on');
    this.welDeliveryStar.filter(`:lt(${this.sDeliveryPoint})`).addClass('on');
    this.welDeliveryTitle.html(aStarTitles[this.sDeliveryPoint]);
    $('._deTitle').addClass('on');
  };

  // 상품 평가 항목 처리
  onClickSurveyItem = e => {
    this.htSurveyItems[$(e.currentTarget).data('questionIdx')] = $(
      e.currentTarget
    ).val();
  };

  // 리뷰 작성시 유의사항 팝업 보이기
  showWriteNoticePopup = () => {
    this.welNoticePopup.show();
  };

  // 리뷰 작성시 유의사항 팝업 숨기기
  hideWriteNoticePopup = () => {
    this.welNoticePopup.hide();
    this.wel.find('[role=writePopup]').hide();
  };

  // 리뷰 내용 변경
  onKeyUp = (text = '') => {
    let sVal = this.welContents.val() || text;

    if (typeof sVal !== 'string') {
      sVal = '';
    }

    const sRegVal = this.getRemoveSpaceAndLine(sVal);
    const nCount = sVal.length;
    let nRegCount = sRegVal.length;

    // text 입력 할 경우 textarea 부모 div 토글
    this.welContents
      .parents('.review_write_textarea:first')
      .toggleClass('on', !!nCount);

    // 공백 제거한 문자열의 길이가 600 넘어갈 때
    if (nRegCount > this.nReviewTextLimit) {
      const nReviewCount = this.nPrevReviewCount || nCount;
      this.welContents.val(sVal.substring(0, nReviewCount));
      nRegCount = this.nReviewTextLimit;
    } else {
      // 입력한 문자 길이 셋팅
      this.nPrevReviewCount = nCount;
    }
    this.welTextCounter.html(nRegCount);
  };

  // 공백, 개행 제거
  getRemoveSpaceAndLine = str => str.replace(/ |\n/gi, '');

  // 업로드된 이미지 삭제
  removeImage = e => {
    $(e.currentTarget)
      .parents('._uploadImage:first')
      .remove();

    // 사진 추가 버튼 활성 상태 변경
    $('#_uploadRImage .input_file').attr('disabled', false);

    if (TMON.sDevice === 'PW') {
      $('#_uploadRImage').show();
    }

    // 현재까지 업로드된 이미지의 수를 뷰에 업로드
    const nUploadedImageLen = $('#_uploadImageList ._uploadImage').length;
    $('.review_write_out .cnt, .review_write_header .cnt').text(
      nUploadedImageLen
    );
  };

  // 리뷰 작성시 혜택 안내 더보기 버튼 제어
  onClickMoreBtn = () => {
    this.welWriteInfo.toggleClass('on');
    this.welWriteInfo
      .find('button>span.text')
      .text(this.welWriteInfo.hasClass('on') ? '닫기' : '더보기');
  };

  // 취소
  onClickCancel = () => {
    this.complete(this.sReviewNo);
  };

  // 등록·수정하기
  onClickRegister = () => {
    const htData = this.validate();
    if (!htData) {
      return;
    }

    if (this.bIsModify) {
      this.modify(htData);
    } else {
      this.register(htData);
    }
  };

  validate() {
    const htReviewData = {
      memberSrl: 0,
      accountSrl: 0,
      useHeader: 'MN, AS',
      isMobileProductReview: 'Y', // 모바일 상품평 여부
      contents: this.getStripHtml(this.welContents.val()),
      imageYn: 'N',
      dealGpoint: this.sSatisfyPoint,
      deliveryGpoint: this.sDeliveryPoint,
      whoUpdate: '',
      uploadImage1: '',
      uploadImage2: '',
      uploadImage3: '',
      uploadImage4: '',
      reviewSurveyInfo: null,
    };

    const sRegContents = this.getRemoveSpaceAndLine(htReviewData.contents);
    const oTempOptions = {
      oButton1: {
        bIsShow: true,
        sContents: '확인',
      },
      oButton2: {},
    };

    if (
      this.sReviewType !== 'S' &&
      (!sRegContents || sRegContents.length < 10 || sRegContents.length > 600)
    ) {
      oTempOptions.sTitle = '리뷰 글자수를 확인해 주세요.';
      oTempOptions.sContents =
        '<p class="contents_text">리뷰는 <span class="bold">한글 기준 10자 이상 600자 미만</span>으로만<br>등록이 가능합니다.</p>';
    } else if (htReviewData.dealGpoint === 0) {
      oTempOptions.sTitle = '리뷰 별점을 확인해 주세요.';
      oTempOptions.sContents =
        '<p class="contents_text">상품 만족도 <span class="bold">별점은 1점 이상</span>이어야<br>등록이 가능합니다.</p>';
    } else if (
      htReviewData.deliveryGpoint === 0 &&
      this.sDealType === 'DELIVERY'
    ) {
      oTempOptions.sTitle = '리뷰 별점을 확인해 주세요.';
      oTempOptions.sContents =
        '<p class="contents_text">배송 만족도 <span class="bold">별점은 1점 이상</span>이어야<br>등록이 가능합니다.</p>';
    } else if (
      this.htSurveyItems !== undefined &&
      Object.keys(this.htSurveyItems).filter(
        elem => this.htSurveyItems[elem] === null
      ).length !== 0
    ) {
      oTempOptions.sTitle = '리뷰 설문 항목을 확인해 주세요.';
      oTempOptions.sContents =
        '<p class="contents_text">리뷰 설문 항목은 <span class="bold">전부 선택</span>되어야<br>등록이 가능합니다.</p>';
    }

    // 설문 항목 추가
    if (this.htSurveyItems !== undefined) {
      htReviewData.reviewSurveyInfo = Object.keys(this.htSurveyItems)
        .map(elem => `${elem}:${this.htSurveyItems[elem]}`)
        .join(',');
    }

    // 이미지 추가
    const welImage = this.wel.find('._uploadImage');
    if (welImage.length) {
      htReviewData.imageYn = 'Y';
      welImage.each((nIndex, el) => {
        htReviewData[`uploadImage${nIndex + 1}`] = $(el).attr('data-img');
      });
    }

    // 리뷰 등록 시 validate check popup
    if (oTempOptions.sTitle && oTempOptions.sContents) {
      this.oAlert.setOptions(oTempOptions);
      this.oAlert.toggle();
      this.oAlert.fBtn1Callback = () => {
        this.oAlert.toggle(false);
      };
      this.oAlert.fCancelBtnCallback = () => {
        this.oAlert.toggle(false);
      };
      return null;
    }

    return htReviewData;
  }

  getStripHtml(sText) {
    return $('<div>')
      .html(sText)
      .text();
  }

  register(htData) {
    if (this.bAjaxRegister === true) {
      return;
    }

    let sUrl = this.oModule
      .getApi()
      .write.replace('{MainDealSrl}', this.sMainDealSrl)
      .replace('{MainBuySrl}', this.sMainBuySrl);

    if (TMON.sDeployPhase !== 'RELEASE') {
      sUrl += '?timeout=5000';
    }

    this.bAjaxRegister = true;
    this.oAjaxGetDealInfo = $.ajax({
      method: 'POST',
      url: sUrl,
      data: htData,
      success: res => {
        this.bAjaxRegister = false;
        /**
         * response 값 정리
         * result: true('성공'), false('실패')
         * status: 120('리뷰 작성 및 적립금 지급'), 0('리뷰만 작성')
         * message: 상황에 따른 message
         */
        if (res.data.message && !res.data.result) {
          alert(res.data.message);
          return;
        }

        if (this.htOptions.onAfterRegisterReview) {
          this.htOptions.onAfterRegisterReview();
        }

        if (TMON.sDevice === 'PW') {
          document.domain = 'tmon.co.kr';

          // 리뷰 보기를 연 창의 함수 호출
          window.opener.toggle_review_button(
            this.sMainBuySrl,
            this.sMainDealSrl,
            false // isWrite
            // === true이면 쓰기 버튼으로 교체
            // === false이면 보기 버튼으로 교체
          );

          window.open('', '_self', '');
          window.close();
        } else {
          const parentViewType = TMON.util.gup('parentViewType');
          if (parentViewType === 'giftbox' || parentViewType === 'delivery') {
            this.alertTicketInfo({
              type: 'changeReviewStatus',
              mainBuySrl: this.sMainBuySrl,
              mainDealSrl: this.sMainDealSrl,
            });
          } else {
            this.alertTicketInfo({
              type: 'reloadApp',
            });
          }
        }
      },
      error: () => {
        this.bAjaxRegister = false;
        alert('리뷰 등록 중 오류가 발생하였습니다\n잠시 후 다시 시도해주세요.');
      },
    });
  }

  /**
   * 리뷰 쓰기일 때, 티켓 딜의 경우 첫번째 티켓 사용 이후 구매후기 공개 얼럿이 뜨도록 추가
   */
  alertTicketInfo(oAction) {
    // 이 성공 및 적립금 지급 message
    const oTempOptions = {
      sTitle: '리뷰 작성이 완료되었습니다.',
      sContents: this.calculateAlertMessage(),
      oButton1: {
        bIsShow: true,
        sContents: '확인',
        color: 'orange',
      },
      oButton2: {},
      bIsShowshareArea: true,
    };

    if (
      this.oAppRating.isShowRequsetAppRating(
        this.sDealType,
        this.sSatisfyPoint,
        this.sDeliveryPoint
      )
    ) {
      oTempOptions.oButton1 = {
        bIsShow: true,
        sContents: '아니요',
        color: 'white',
      };

      oTempOptions.oButton2 = {
        bIsShow: true,
        sContents: '좋아요',
        color: 'orange',
      };
    }

    this.showCompleteAlert(oTempOptions, oAction);
  }

  calculateAlertMessage() {
    const messages = [];

    const sPointMsg = `<p class="contents_text">
                관련 정책에 따라 적립금이 지급됩니다.
                <br>(리뷰 작성 혜택 안내 참조)
                <br>[마이티몬 > 티몬캐시·적립금]에서
                <br>적립금 내역을 확인해주세요.
            </p>`;

    const appReviewRequestMsg = `<div class="write_pop_line"></div>
            <p class="contents_text"><strong>티몬 앱의 리뷰도 남겨주시겠어요?</strong></p>`;

    messages.push(sPointMsg);

    if (
      this.oAppRating.isShowRequsetAppRating(
        this.sDealType,
        this.sSatisfyPoint,
        this.sDeliveryPoint
      )
    ) {
      messages.push(appReviewRequestMsg);
    }

    // 티켓딜 리뷰 작성 및 적립금 지급일 경우 pointMsg + ticketMsg
    return messages.join('');
  }

  showCompleteAlert(oOptions, oAction) {
    this.oAlert.setOptions(oOptions);
    this.oAlert.toggle();

    if (
      this.oAppRating.isShowRequsetAppRating(
        this.sDealType,
        this.sSatisfyPoint,
        this.sDeliveryPoint
      )
    ) {
      this.oAlert.fBtn1Callback = () => {
        this.oAppRating.saveResponseToAppRating(false);

        this.oAlert.toggle(false);
        this.complete(this.sReviewNo, oAction);
      };

      this.oAlert.fBtn2Callback = () => {
        this.oAppRating.saveResponseToAppRating(true);

        this.oAlert.toggle(false);
        this.complete(this.sReviewNo, oAction);
        this.oAppRating.gotoMarket();
      };
    } else {
      this.oAlert.fBtn1Callback = () => {
        this.oAlert.toggle(false);
        this.complete(this.sReviewNo, oAction);
      };
    }
    this.oAlert.fCancelBtnCallback = () => {
      this.oAlert.toggle(false);
      this.complete(this.sReviewNo, oAction);
    };
  }

  modify(htData) {
    if (this.bAjaxmodify === true) {
      return;
    }

    this.bAjaxmodify = true;
    this.oAjaxGetDealInfo = $.ajax({
      method: 'POST',
      url: this.oModule
        .getApi()
        .modify.replace('{ReviewNo}', this.sReviewNo)
        .replace('{MainDealSrl}', this.sMainDealSrl)
        .replace('{MainBuySrl}', this.sMainBuySrl),
      data: htData,
      success: res => {
        this.bAjaxmodify = false;

        if (res.data.message) {
          alert(res.data.message);
          return;
        }

        // 리뷰 데이터 업데이트
        this.oModule.getReviewUpdate(this.sReviewNo);

        if (this.htOptions.onAfterModifyReview) {
          this.htOptions.onAfterModifyReview();
        }
        // 리뷰 수정후 모듈을 부른 페이지에서 업데이트가 되어야 할 경우
        if (this.htOptions.onUpdateReview) {
          this.getReviewForUpdate(this.sReviewNo);
        } else {
          this.afterComplete(this.sReviewNo);
        }

        if (TMON.sDevice === 'PW') {
          document.domain = 'tmon.co.kr';

          // 리뷰 보기를 연 창의 함수 호출
          window.opener.toggle_review_button(
            this.sMainBuySrl,
            this.sMainDealSrl,
            false // isWrite
            // === true이면 쓰기 버튼으로 교체
            // === false이면 보기 버튼으로 교체
          );

          window.open('', '_self', '');
          window.close();
        }
      },
      error: () => {
        this.bAjaxmodify = false;
        alert('리뷰 수정 중 오류가 발생하였습니다\n잠시 후 다시 시도해주세요.');
      },
    });
  }

  getReviewForUpdate(sReviewNo) {
    $.ajax({
      url: this.oModule.getApi().getReview.replace('{ReviewNo}', sReviewNo),
      data: {
        useHeader: TMON.bLogin ? 'MN' : '',
        useDealInfo: false,
      },
      success: res => {
        if (!res || !res.data) {
          this.afterComplete();
          return;
        }

        this.htOptions.onUpdateReview(res.data);
        this.afterComplete();
      },
    });
  }

  afterComplete(sReviewNo) {
    if (this.bIsModify && TMON.sDevice !== 'PW') {
      this.oAlert.setOptions({
        sTitle: '작성하신 리뷰가 수정되었습니다.',
        sContents: '',
        oButton1: {
          bIsShow: true,
          sContents: '확인',
        },
        oButton2: {},
      });
      this.oAlert.toggle();
      this.oAlert.fBtn1Callback = () => {
        this.oAlert.toggle(false);
        this.complete(sReviewNo);
      };
      this.oAlert.fCancelBtnCallback = () => {
        this.oAlert.toggle(false);
        this.complete(sReviewNo);
      };
    } else if (this.bIsModify) {
      this.complete(sReviewNo);
    }
  }

  complete(sReviewNo, oAction) {
    if (this.oModule.getPrevView() && sReviewNo) {
      const sPrevView = this.oModule.getPrevView();
      this.oModule.reset();
      this.oModule.show(sPrevView, sReviewNo);
      this.hide();
      return;
    }

    if (this.htOptions.onCloseReview) {
      this.htOptions.onCloseReview(oAction);
    }

    this.oModule.reset();
  }

  hide() {
    if (TMON.sDevice === 'MA' || TMON.sDevice === 'MI') {
      TMON.app.callApp(
        'webview',
        'setWebProperties',
        '{"isKeyboardResize":false}'
      ); // Android 앱에서 텍스트 입력창이 키보드에 가려지지않게 자동으로 스크롤 되도록 callApp을 날려준다.
    }
    $('body').removeClass('review-write');
    if (this.wel) {
      this.wel.remove();
    }
  }

  showToast(sText) {
    if (!this.wel || TMON.sDevice === 'PW') {
      return;
    }

    this.wel
      .find('[data-role=review_write_toast]')
      .stop()
      .find('.text')
      .html(sText);
    this.wel
      .find('[data-role=review_write_toast]')
      .show()
      .delay(2000)
      .fadeOut('slow');
  }
}
